import api from "./api";

export type QuizCategory = {
  id: string;
  name: string;
  title: string;
  description: string | null;
  image_url: string | null;
  is_active: boolean;
  order_no: number;
  created_at: string;
  updated_at: string;
  // Number of quizzes in this category (from the list endpoint).
  quiz_count?: number;
};

/**
 * Get all quiz categories
 */
export async function getQuizCategories(showAll = false) {
  const qs = showAll ? "?all=true" : "";
  const { data } = await api.get<QuizCategory[]>(`/quiz-categories${qs}`);
  return data;
}

/**
 * Get single quiz category by ID
 */
export async function getQuizCategory(categoryId: string) {
  const { data } = await api.get<QuizCategory>(`/quiz-categories/${categoryId}`);
  return data;
}

/**
 * Create new quiz category
 */
export async function createQuizCategory(payload: {
  name: string;
  title: string;
  description?: string;
  image_url?: string;
  is_active?: boolean;
  order_no?: number;
}) {
  const { data } = await api.post<QuizCategory>("/quiz-categories", payload);
  return data;
}

/**
 * Update quiz category
 */
export async function updateQuizCategory(
  categoryId: string,
  payload: {
    name?: string;
    title?: string;
    description?: string;
    image_url?: string;
    is_active?: boolean;
    order_no?: number;
  }
) {
  const { data } = await api.patch<QuizCategory>(`/quiz-categories/${categoryId}`, payload);
  return data;
}

/**
 * Delete quiz category
 */
export async function deleteQuizCategory(categoryId: string) {
  const { data } = await api.delete(`/quiz-categories/${categoryId}`);
  return data;
}
